import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { customAxiosInstance } from '../axios/axiosInstance';
import { AxiosResponse } from 'axios';
import { IError } from '../interfaces/IError';
import { axiosErrorHandler } from '../axios/axiosError';
import { ISqsAccessManageRepository } from '../interfaces/ISqsAccessManageRepository';
import {
  ErrorResponse,
  GetSqsMessageResponse,
  GetSqsMessageResponseInfoInner,
  PostSqsMessageResponse,
  PostSqsMessageResponseInfo,
  SqsAccessManageApi,
  DeleteSqsStatusInfoFromDynamoDbResponseInfo,
  DeleteSqsStatusInfoFromDynamoDbResponse,
} from '../axios/generated/sqsAccessManage/api';

/**
 * 仕入先内示APIの実装クラス
 */
export class SqsAccessManageRepository implements ISqsAccessManageRepository {
  /**
   * SQSにメッセージキューを追加する
   */
  async post(): Promise<INetworkResult<PostSqsMessageResponseInfo, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const sqsAccessManageApi = new SqsAccessManageApi(undefined, undefined, axiosInstance);
    // APIを叩く
    let apiResponse: AxiosResponse<PostSqsMessageResponse, ErrorResponse>;

    try {
      apiResponse = await sqsAccessManageApi.postSqsMessage();
      switch (apiResponse.status) {
        case 200:
          const result: PostSqsMessageResponseInfo = apiResponse.data.result;
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (error) {
      return { status: { type: 'error', error: axiosErrorHandler(error) } };
    }
  }

  /**
   * SQSをトリガーとする処理の進行状況一覧をDynamoDBから取得する
   */
  async get(): Promise<INetworkResult<GetSqsMessageResponseInfoInner[], IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const sqsAccessManageApi = new SqsAccessManageApi(undefined, undefined, axiosInstance);
    // APIを叩く
    let apiResponse: AxiosResponse<GetSqsMessageResponse, ErrorResponse>;

    try {
      apiResponse = await sqsAccessManageApi.getSqsMessage();
      switch (apiResponse.status) {
        case 200:
          const result: GetSqsMessageResponseInfoInner[] = apiResponse.data.result;
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (error) {
      return { status: { type: 'error', error: axiosErrorHandler(error) } };
    }
  }

  /**
   * SQSをトリガーとする処理の進行状況をDynamoDBから削除する
   * @param requestId - 削除対象の情報が持つリクエストID
   */
  async delete(requestId: string): Promise<INetworkResult<DeleteSqsStatusInfoFromDynamoDbResponseInfo, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const sqsAccessManageApi = new SqsAccessManageApi(undefined, undefined, axiosInstance);
    // APIを叩く
    let apiResponse: AxiosResponse<DeleteSqsStatusInfoFromDynamoDbResponse, ErrorResponse>;

    try {
      apiResponse = await sqsAccessManageApi.deleteSqsStatusInfoFromDynamoDb(requestId);
      switch (apiResponse.status) {
        case 200:
          const result: DeleteSqsStatusInfoFromDynamoDbResponseInfo = apiResponse.data.result;
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (error) {
      return { status: { type: 'error', error: axiosErrorHandler(error) } };
    }
  }
}
